import { setProcurementItems } from '../State/procurementItems';
import { clearDeletedProcurementItemIds } from '../State/deletedProcurementItemIds';
import { createOrderProcurementItem, updateOrderProcurementItem, deleteOrderProcurementItem } from '../../../HttpRequests/orderProcurement';
import { Modal } from 'antd';

export default () => async (dispatch, getState) => {
  const state = getState();
  const procurementItems = state.screens.OrderView.procurementItems;
  const deletedIds = state.screens.OrderView.deletedProcurementItemIds;
  const orderId = state.screens.OrderView.order.id;

  try {
    // Delete queued items first
    for (const id of deletedIds) {
      await deleteOrderProcurementItem(id);
    }
    dispatch(clearDeletedProcurementItemIds());

    const updatedItems = [];
    
    for (let i = 0; i < procurementItems.length; i++) {
      const item = procurementItems[i];
      
      console.log('Processing item:', item);
      
      // Skip items pending deletion - handled above
      if (item._pendingDelete) continue;

      // Skip items without required fields
      if ((!item.supplier_id && !item.supplier_name) || !item.item_name) {
        console.log('Skipping incomplete item:', item);
        updatedItems.push(item); // Keep incomplete items in state
        continue;
      }

      // Prepare data for API
      const data = {
        supplier_id: item.supplier_id || null,
        supplier_name: item.supplier_name,
        supplier_item_id: item.supplier_item_id,
        item_name: item.item_name,
        description: item.description || '',
        item_code: item.item_code || '',
        unit_of_measure: item.unit_of_measure,
        quantity: item.quantity,
        unit_cost: item.unit_cost,
        currency: item.currency || 'GBP',
        tax_rate: item.tax_rate || 0,
        markup_percentage: item.markup_percentage || 0,
        lead_time_days: item.lead_time_days || 0,
        required_by_date: item.required_by_date,
        notes: item.notes || '',
        status: item.status || 'pending',
      };

      console.log('Sending data to API:', data);
      
      if (typeof item.id === 'string' && item.id.startsWith('_new_')) {
        // Create new item
        console.log('Creating new item for order:', orderId);
        const response = await createOrderProcurementItem(orderId, data);
        console.log('Create response:', response);
        updatedItems.push(response.data.data);
      } else {
        // Update existing item
        console.log('Updating existing item:', item.id);
        const response = await updateOrderProcurementItem(item.id, data);
        console.log('Update response:', response);
        updatedItems.push(response.data.data);
      }
    }

    // Update all items in state
    dispatch(setProcurementItems(updatedItems));

    // Don't show success modal - let the main save handler show the success message
  } catch (error) {
    console.error('Error saving procurement items:', error);
    const message = (error.response && error.response.data && error.response.data.message) || 'Failed to save procurement items';
    Modal.error({
      title: 'Error',
      content: message,
    });
    // Re-throw error so main save handler knows procurement save failed
    throw error;
  }
};
